import { getSuppliersSetup, getSuppliers, deleteOnlineCouponDetails, insertExcel } from '@/services/suppliers.js'
import jsonData from './jsonData.js'
import allButton from '@/components/allButton'
import searchForm from '@/components/searchForm'
import createTable from '@/components/createTable'
import dialogEffect from '@/components/dialogEffect'
import importButton from '@/components/importButton'
import { mixin } from '@/mixins/mixin'
export default {
  name: 'SupplierList',
  mixins: [mixin],
  components: {
    searchForm,
    createTable,
    allButton,
    dialogEffect,
    importButton
  },
  data () {
    return {
      tableDataItem: jsonData.tableDataItem,
      insertExcel
    }
  },
  watch: {
    $route (to, from) {
      // console.log(from)
      // if (from.name === 'managerUserOrderView') {
      //   this.$nextTick(() => {
      //     this.search()
      //     this.$refs.createTable.$refs.table.doLayout()
      //   })
      // }
    }
  },
  created () {
    this.queryData(getSuppliersSetup)
  },
  activated () {
    if (this.isActive) this.queryData(getSuppliersSetup)
    this.isActive = true
  },
  methods: {
    // 点击操作按钮
    async handleClick (type, data) {
      if (type === 'create') {
        this.$router.push({
          name: 'suppliersAdd'
        })
      }
      if (type?.action === 'view') {
        this.$router.push({
          name: 'suppliersDetail',
          params: {
            id: data.id.value
          }
        })
      }
      if (type?.action === 'create') {
        this.$router.push({
          name: 'suppliersAdd'
        })
      }
      if (type?.action === 'edit') {
        this.$router.push({
          name: 'suppliersEdit',
          params: {
            id: data.id.value
          }
        })
      }
      if (type?.action === 'destroy') {
        this.deleteClick(data, deleteOnlineCouponDetails)
      }
    },
    handleSwitchChange (data) {},
    // 查询
    search (data) {
      if (data) this.searchData = data
      const { page, per_page } = this.pageData
      Object.assign(this.searchData, { page, per_page })
      this.loading = true
      getSuppliers(this.searchData).then(res => {
        if (res.data) {
          this.tableData = res.data.objects
          this.tabData = res.data.scopes
          Object.assign(this.pageData, res.data.pagination)
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
